import {useState,useEffect} from 'react'
import {Combobox} from '@headlessui/react'
import axios from '../../axios'
const Username = ({value,handleInputChange,dont,imp}) => {
    const [users, setUsers] = useState([]);
    const [err,setErr]=useState(false)
  
    useEffect(() => {
      const userNames = async () => {
        try {
          const response = await axios.get('/users/getAdminList'); // Replace '/api/usernames' with your actual API endpoint
        setUsers(response.data.users);
          // console.log(users);
        } catch (error) {
          console.error('Error fetching usernames:', error);
          setErr(true)
        }
      };
  
      userNames();
    }, []);
  
    return (
      <div className="flex flex-col">
        <label htmlFor='username'className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Contact Person Id{imp&&<span className='text-red-500'> *</span>}</label>
        {err?(<input 
        id='username'
        name='username'
        type='text'
        disbaled={dont}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
       value={value}
       onChange={handleInputChange}/>):(<>
        <select
        value={value}
        onChange={handleInputChange}
        disabled={dont}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="" disabled>---Select---</option>

          {users.map((user) => (
            <option key={user.user_id} value={user.user_id}>
              {user.username}
            </option>
          ))}
        </select>
        </>)}
        
      </div>
    );
  };
  
  export default Username;